// Accent themes + light/dark mode applied via CSS variables on <html>

export const ACCENTS = {
  sunset: { name: 'Sunset', c1: '#f97316', c2: '#ea580c', glow: 'rgba(200,90,20,0.2)' },
  ocean:  { name: 'Ocean',  c1: '#3b82f6', c2: '#2563eb', glow: 'rgba(40,90,200,0.2)' },
  forest: { name: 'Forest', c1: '#10b981', c2: '#059669', glow: 'rgba(16,150,110,0.2)' },
  royal:  { name: 'Royal',  c1: '#8b5cf6', c2: '#7c3aed', glow: 'rgba(120,60,200,0.2)' },
};

export function applyTheme({ accent = 'sunset', mode = 'dark' } = {}) {
  const root = document.documentElement;
  const a = ACCENTS[accent] || ACCENTS.sunset;
  root.style.setProperty('--accent', a.c1);
  root.style.setProperty('--accent-2', a.c2);
  root.style.setProperty('--accent-grad', `linear-gradient(135deg, ${a.c1}, ${a.c2})`);
  root.style.setProperty('--accent-glow', a.glow);
  root.setAttribute('data-mode', mode);
  const v = mode === 'light'
    ? {
        '--bg': '#eceae4',
        '--text': '#16161d',
        '--text-dim': 'rgba(20,20,30,0.6)',
        '--text-mute': 'rgba(20,20,30,0.4)',
        '--surface': 'rgba(0,0,0,0.035)',
        '--surface-border': 'rgba(0,0,0,0.1)',
        '--card-grad': 'linear-gradient(150deg, #ffffff 0%, #f6f4ef 100%)',
        '--card-border': 'rgba(0,0,0,0.1)',
        '--card-shadow': '0 8px 24px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.6)',
        '--head-bg': 'rgba(0,0,0,0.05)',
        '--head-2': 'rgba(0,0,0,0.028)',
        '--row-alt': 'rgba(0,0,0,0.025)',
        '--divider': 'rgba(0,0,0,0.07)',
        '--topbar': 'rgba(255,255,255,0.82)',
        '--pos': '#059669',
        '--neg': '#dc2626',
      }
    : {
        '--bg': '#131216',
        '--text': '#f5f0e8',
        '--text-dim': 'rgba(255,255,255,0.55)',
        '--text-mute': 'rgba(255,255,255,0.4)',
        '--surface': 'rgba(255,255,255,0.05)',
        '--surface-border': 'rgba(255,255,255,0.09)',
        '--card-grad': 'linear-gradient(150deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 100%)',
        '--card-border': 'rgba(255,255,255,0.09)',
        '--card-shadow': '0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)',
        '--head-bg': 'rgba(0,0,0,0.22)',
        '--head-2': 'rgba(0,0,0,0.12)',
        '--row-alt': 'rgba(255,255,255,0.015)',
        '--divider': 'rgba(255,255,255,0.06)',
        '--topbar': 'rgba(20,20,20,0.85)',
        '--pos': '#34d399',
        '--neg': '#f87171',
      };
  for (const k in v) root.style.setProperty(k, v[k]);
}

export function loadThemePref() {
  try { return JSON.parse(localStorage.getItem('theme') || '{}'); } catch { return {}; }
}
export function saveThemePref(t) {
  localStorage.setItem('theme', JSON.stringify(t));
}

// Member display: label + avatar. HUF always uppercase.
export function memberLabel(entity, members) {
  if (entity === 'HUF') return 'HUF';
  const custom = members?.[entity]?.label;
  if (custom) return custom;
  return entity.charAt(0) + entity.slice(1).toLowerCase();
}
